// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__9EH2j","options":"AnswerScale_options__1jLkN","selected":"AnswerScale_selected__26opz"};